import { createAction, createReducer } from '@reduxjs/toolkit';
import { CertificatesState } from './certificatesTypes';
import { Certificate } from '../../types/rest/assetCatalogTypes';

const initialState: CertificatesState = {
  certificates: [],
  isLoading: false,
};

export const getCertificates = createAction<Certificate[]>('GET_CERTIFICATES');
export const setIsLoadingCertificate = createAction<boolean>('SET_IS_LOADING_CERTIFICATE');

export const certificatesReducer = createReducer(initialState, builder => {
  builder.addCase(setIsLoadingCertificate, (state, action) => {
    state.isLoading = action.payload;
  });

  builder.addCase(getCertificates, (state, action) => {
    state.certificates = action.payload;
  });
});
